import { Image } from 'antd';
import { useMount } from "../Render";
import { jsx as _jsx } from "react/jsx-runtime";
export var usePreviewImage = function usePreviewImage() {
  var mount = useMount();
  return function (url) {
    var _mount = mount( /*#__PURE__*/_jsx(Image, {
        wrapperStyle: {
          display: 'none'
        },
        preview: {
          visible: true,
          onVisibleChange: function onVisibleChange() {
            return unmount();
          }
        },
        src: url
      })),
      unmount = _mount.unmount;
  };
};